/* Shoe Creatives — Wishlist (saved items) */

const STORAGE_KEY = 'sc_wishlist';
const EVENT_NAME = 'wishlist:updated';
let memoryStore = null;

const SUPABASE_URL = 'https://jtitgxdptkpnsqhuqavh.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0aXRneGRwdGtwbnNxaHVxYXZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM0NjY1MzksImV4cCI6MjA5OTA0MjUzOX0.DgJkUWXhWngeaWAxpaK4PiC7Ilg1dPIYDiDdbbkjpRQ';
const VISITOR_KEY = 'sc_visitor_id';

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);

    if (!id) {
      id = `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }

    return id;
  } catch (e) {
    return `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}

function absoluteUrl(url) {
  try {
    return new URL(url || '/', window.location.origin).href;
  } catch (e) {
    return url || '';
  }
}

function getRegionFromCountryCode(countryCode) {
  const code = String(countryCode || '').toUpperCase();

  const gcc = ['QA', 'AE', 'SA', 'KW', 'BH', 'OM'];

  const europe = [
    'PT', 'ES', 'FR', 'IT', 'DE', 'NL', 'BE', 'DK', 'SE', 'NO',
    'FI', 'IE', 'GB', 'CH', 'AT', 'PL', 'CZ', 'GR'
  ];

  const northAmerica = ['US', 'CA'];

  const asia = [
    'JP', 'KR', 'CN', 'HK', 'SG', 'MY', 'TH', 'ID', 'PH', 'VN'
  ];

  if (gcc.includes(code)) return 'GCC';
  if (europe.includes(code)) return 'Europe';
  if (northAmerica.includes(code)) return 'North America';
  if (asia.includes(code)) return 'Asia';

  return code ? 'Other' : 'Unknown';
}

function trackWishlistSave(item) {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return;
  if (!item || !item.id) return;

  const payload = {
  shopify_product_id: String(item.id),
  product_title: item.title || '',
  product_vendor: item.vendor || '',
  product_image_url: item.image || '',
  product_url: absoluteUrl(item.url),
  visitor_id: getVisitorId(),
  source_page: window.location.pathname,
  source_url: window.location.href,
  referrer: document.referrer || null,

  country_code: item.countryCode || null,
  country: item.countryName || null,
  market_handle: item.marketHandle || null,
  region: getRegionFromCountryCode(item.countryCode),

  save_status: 'saved',
  saved_at: new Date().toISOString()
};

  fetch(`${SUPABASE_URL}/rest/v1/wishlist_saves`, {
    method: 'POST',
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      Prefer: 'return=minimal'
    },
    body: JSON.stringify(payload),
    keepalive: true
  }).catch((error) => {
    console.error('Wishlist save tracking failed:', error);
  });
}

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    const store = parsed && typeof parsed === 'object' ? parsed : {};
    memoryStore = store;
    return store;
  } catch (e) {
    if (!memoryStore) memoryStore = {};
    return memoryStore;
  }
}

function writeStore(store) {
  memoryStore = store;
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(store)); } catch (e) {}
  document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { store } }));
}

export const Wishlist = {
  getAll() { return { ...readStore() }; },
  has(id) { return Object.prototype.hasOwnProperty.call(readStore(), String(id)); },
  add(item) {
  const s = readStore();
  const id = String(item.id);

  s[id] = {
  id,
  title: item.title || '',
  vendor: item.vendor || '',
  image: item.image || '',
  url: item.url || '#',
  countryCode: item.countryCode || '',
  countryName: item.countryName || '',
  marketHandle: item.marketHandle || '',
  addedAt: Date.now()
};

  writeStore(s);
  trackWishlistSave(s[id]);
},
  remove(id) { const s = readStore(); delete s[String(id)]; writeStore(s); },
  toggle(item) { const id = String(item.id); if (this.has(id)) { this.remove(id); return false; } this.add(item); return true; },
  count() { return Object.keys(readStore()).length; },
  clear() { writeStore({}); },
};

function findButton(t) { return t instanceof Element ? t.closest('wishlist-button') : null; }

function syncButtonState(btn) {
  const s = Wishlist.has(btn.dataset.productId);
  btn.classList.toggle('is-saved', s);
  btn.setAttribute('aria-pressed', s ? 'true' : 'false');
}

if (!window.__scWishlistBound) {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const removeBtn = event.target.closest('[data-remove-id]');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      Wishlist.remove(removeBtn.getAttribute('data-remove-id'));
      return;
    }

    const btn = findButton(event.target);
    if (btn) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      Wishlist.toggle({
  id: btn.dataset.productId,
  title: btn.dataset.productTitle,
  vendor: btn.dataset.productVendor,
  image: btn.dataset.productImage,
  url: btn.dataset.productUrl,
  countryCode: btn.dataset.countryCode,
  countryName: btn.dataset.countryName,
  marketHandle: btn.dataset.marketHandle,
});
    }
  }, true);

  document.addEventListener(EVENT_NAME, () => {
    document.querySelectorAll('wishlist-button').forEach(syncButtonState);
  });

  window.__scWishlistBound = true;
}

class WishlistButton extends HTMLElement {
  connectedCallback() { syncButtonState(this); }
}
if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);

function escapeHtml(str) {
  const d = document.createElement('div');
  d.textContent = str || '';
  return d.innerHTML;
}

function formatRowHtml(item) {
  const img = item.image
    ? `<img class="cnav-cart__item-img" src="${item.image}" alt="${escapeHtml(item.title)}">`
    : '<div class="cnav-cart__item-img"></div>';
  return `
    <div class="cnav-cart__item" data-wishlist-row="${item.id}">
      <a href="${item.url}">${img}</a>
      <div class="cnav-cart__item-info">
        ${item.vendor ? `<p class="cnav-cart__item-price">${escapeHtml(item.vendor.toUpperCase())}</p>` : ''}
        <a href="${item.url}" class="cnav-cart__item-title">${escapeHtml(item.title)}</a>
      </div>
      <button type="button" class="cnav-cart__item-remove" data-remove-id="${item.id}" aria-label="Remove ${escapeHtml(item.title)}">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
  `;
}

export function renderWishlistDrawer(bodyEl, emptyMessage) {
  const items = Object.values(Wishlist.getAll()).sort((a, b) => b.addedAt - a.addedAt);
  if (items.length === 0) {
    bodyEl.innerHTML = `<p class="cnav-cart__empty">${emptyMessage || 'No saved items yet'}</p>`;
    return;
  }
  bodyEl.innerHTML = items.map(formatRowHtml).join('');
}

export function wishlistBadgeCount() { return Wishlist.count(); }